import styled from 'styled-components';

import { Stack } from 'common/components/cookbook/Stack';
import { StyledIcon } from 'common/components/cookbook/StyledIcon';
import { useFormatMessage } from 'common/hooks/useFormatMessage';
import { useSelectedCountry } from 'common/hooks/useSelectedCountry';
import { useUserLocale } from 'common/hooks/useUserLocale';
import { truncateMiddle } from 'common/utils/stringUtils';

import { OverridesSummary } from '../api-types';
import { getTagIcon } from './utils';

const SubheaderContainer = styled(Stack)`
  padding-top: 4px;
`;

type Props = {
  overrideSummary: OverridesSummary;
};

export const OverrideModalHeaderSubsection = ({ overrideSummary }: Props) => {
  const locale = useUserLocale();
  const countryDefaultLang = useSelectedCountry().data?.defaultLanguageCode;
  const format = useFormatMessage();

  const { productName, overrideType, reasonCode } = overrideSummary;
  const productNameTranslation =
    productName?.find((name) => name.lang === locale) ||
    productName?.find((name) => name.lang === countryDefaultLang);

  return (
    <SubheaderContainer direction="row" gap="narrowMedium" wrap="wrap" dividers>
      {productNameTranslation && <span>{truncateMiddle(productNameTranslation.value, 30)}</span>}
      {overrideType && (
        <Stack direction="row" alignItems="center" gap="narrowMedium">
          <StyledIcon as={getTagIcon(overrideType)} />
          {format(`forecasting.override_type:${overrideType}`)}
        </Stack>
      )}
      {reasonCode && (
        <Stack direction="row" alignItems="center" gap="narrowMedium">
          {format(`forecasting.reason_code:${reasonCode}`)}
        </Stack>
      )}
    </SubheaderContainer>
  );
};
